import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import TdGrid from './TdGrid';

class InfoKamar extends PureComponent {

    componentDidMount = () => {

    }

    render() {
        const data = this.props.data;
        const tipe = this.props.tipe;
        return (
            <div>
                {
                    data.length > 0 ? data.map((val, i) => {
                        return (
                            <Row style={{
                                fontSize: this.props.fontSize
                            }} key={'row_' + i}>

                                {
                                    tipe === 1 ?
                                        <Col span={4} guttter={0}>
                                            <TdGrid odd={i % 2}>{val.nama_kelas}</TdGrid>
                                        </Col> : ''
                                }

                                <Col span={tipe === 1 ? 4 : 8} guttter={0}>
                                    <TdGrid odd={i % 2}>{val.nama_kamar}</TdGrid>
                                </Col>
                                <Col span={4}>
                                    <TdGrid odd={i % 2}>{val.kapasitas}</TdGrid>
                                </Col>
                                <Col span={4}>
                                    <TdGrid odd={i % 2}>{val.kapasitas - val.sisa}</TdGrid>
                                </Col>
                                <Col span={4}>
                                    <TdGrid odd={i % 2}>
                                        <span className="badge" style={{
                                            color: 'white',
                                            backgroundColor: val.sisa === 0 ? '#dc3545' : '#007bff',
                                            fontSize: this.props.fontSize
                                        }}>
                                            {val.sisa}
                                        </span>
                                    </TdGrid>
                                </Col>
                                <Col span={4}>
                                    <TdGrid odd={i % 2}>{val.tarif.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")}</TdGrid>
                                </Col>
                            </Row>
                        )
                    })
                        : (
                            <div>Data tidak ditemukan!</div>
                        )
                }
            </div>
        );
    }
}

InfoKamar.propTypes = {

};

export default InfoKamar;